<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN'">
        <v-autocomplete
          dense
          outlined
          :items="empresas"
          v-model="empresaSelecionada"
          item-text="nome"
          item-value="id"
          label="Selecione uma empresa"
          @change="atualizaDados"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-btn dark @click="carregaPessoas(empresaSelecionada ? empresaSelecionada : companyobj.id)" color="#263680">
          <v-icon left>mdi-refresh</v-icon>
          Recarregar
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :class="{ 'table-blur': tabela.carregamento }"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          :items-per-page="tabela.itensPorPagina"
          disable-sort
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
          hide-default-footer
          disable-pagination
          :page.sync="tabela.pagina"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">PESSOAS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                label="Pesquisar (nome ou CPF)"
                hide-details
                outlined
                dense
                @keydown.enter="buscarItem"
              ></v-text-field>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" small icon color="primary" @click="buscarItem" :disabled="tabela.busca.length < 3" outlined style="margin: 0px 10px 0px 10px">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Buscar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" small icon color="red" outlined :disabled="!tabela.modoBusca" @click="sairModoBusca">
                    <v-icon>mdi-cancel</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar busca</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <v-btn text @click="abrirDialogo" tile color="#263680" :disabled="user.tipo == 'ADMIN' ? empresaSelecionada == '' : false">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" :disabled="item.logsEnvioLeito.length == 0">
                  <v-icon @click="verLogs(item)" color="#1893bf">mdi-view-list</v-icon>
                </v-btn>
              </template>
              <span>Ver logs</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="associarItem(item)" color="green">mdi-account-arrow-right</v-icon>
                </v-btn>
              </template>
              <span>Associar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="desassociarItem(item)" color="red">mdi-account-remove</v-icon>
                </v-btn>
              </template>
              <span>Desassociar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.sexo`]="{ item }">
            <p v-if="item.sexo == 'MASCULINO'" style="margin: 0px">Masculino</p>
            <p v-if="item.sexo == 'FEMININO'" style="margin: 0px">Feminino</p>
          </template>
          <template v-slot:[`item.tipo`]="{ item }">
            <td>{{ retornaTipoPessoa(item) }}</td>
          </template>
          <template v-slot:[`item.foto`]="{ item }">
            <td>
              <v-avatar size="40">
                <v-img :src="item.foto"></v-img>
              </v-avatar>
            </td>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip dark :color="corStatus(item.status)">{{ item.status || 'N/A' }}</v-chip>
          </template>
          <template v-slot:no-data>
            <v-row style="margin: 0px">
              <v-col>
                <v-alert v-if="user.tipo == 'ADMIN' && empresaSelecionada == ''" dark dense text outlined color="info" icon="info" style="margin: 0px">Selecione uma empresa para visualizar as pessoas</v-alert>
                <v-alert v-if="empresaSelecionada" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhuma pessoa cadastrada</v-alert>
                <v-alert v-if="user.tipo != 'ADMIN'" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhuma pessoa cadastrada</v-alert>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12">
        <v-pagination
          v-model="tabela.pagina"
          :length="totalPages"
          :total-visible="10"
          @input="pegaPaginaPaginacao"
        ></v-pagination>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoPessoa" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text style="padding-bottom: 0px; padding-top: 10px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="Nome*"
                outlined
                dense
                hide-details
                v-model="editedItem.nome"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="CPF*"
                outlined
                dense
                hide-details
                v-model="editedItem.cpf"
                v-mask="'###.###.###-##'"
                type="tel"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-select
                :items="tipos"
                item-text="text"
                item-value="value"
                label="Tipo*"
                outlined
                dense
                hide-details
                v-model="editedItem.tipo"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6" v-if="editedItem.tipo == 'ALUNO'">
              <v-text-field
                label="Turma*"
                outlined
                dense
                hide-details
                v-model="editedItem.turma"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6" v-if="editedItem.tipo == 'ALUNO'">
              <v-text-field
                label="Turno*"
                outlined
                dense
                hide-details
                v-model="editedItem.turno"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6" v-if="editedItem.tipo == 'ALUNO'">
              <v-text-field
                label="Sala*"
                outlined
                dense
                hide-details
                v-model="editedItem.sala"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6" v-if="editedItem.tipo == 'ALUNO'">
              <v-text-field
                label="Matrícula*"
                outlined
                dense
                hide-details
                v-model="editedItem.matricula"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" v-if="editedItem.tipo === 'ALUNO'">
              <v-autocomplete
                :loading="autocompleteResponsavel.carregamento"
                :search-input.sync="autocompleteResponsavel.busca"
                :items="responsaveis"
                :filter="filterResponsaveis"
                item-text="nome"
                item-value="id"
                label="Vincular a Responsáveis"
                outlined
                hide-details
                v-model="editedItem.responsavelId"
                no-data-text="Nenhum responsável encontrado"
                multiple
                clearable
              >
                <template v-slot:item="{ item }">
                  <v-list-item-avatar>
                    <v-img :src="item.foto"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.nome }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.cpf.length == 11 ? mascaraCPF(item.cpf) : item.cpf }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="remove(data.item)"
                  >
                    <v-avatar left>
                      <v-img :src="data.item.foto"></v-img>
                    </v-avatar>
                    {{ data.item.nome }}
                  </v-chip>
                </template>
              </v-autocomplete>
              <div class="caption text-caption mt-1" style="color: rgba(0, 0, 0, 0.6);">
                Selecione um responsável para vincular a este aluno
              </div>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-card outlined>
                <v-card-title style="padding: 10px 16px 10px 16px">Foto</v-card-title>
                <v-card-text style="padding: 0px">
                  <v-img
                    v-if="editedItem.foto"
                    :src="editedItem.foto"
                    contain
                    width="100%"
                    height="100%"
                  ></v-img>
                  <v-alert
                    v-if="!editedItem.foto"
                    type="info"
                    style="margin: 0px"
                  >
                    <p>Nenhuma foto</p>
                    <v-btn outlined @click="dialogoCamera = true">Capturar Foto</v-btn>
                    <br>
                    <file-upload
                      class="btn btn-primary mt-1"
                      input-id="file1"
                      extensions="png,gif,jpeg,jpg"
                      accept="image/png,image/gif,image/jpeg,image/jpg"
                      post-action="/upload/post"
                      v-model="filesRg1"
                      @input-filter="inputFilter"
                      @input-file="inputFileRg1"
                      ref="upload1"
                    >
                      <v-btn outlined>Selecionar Foto</v-btn>
                      <p id="foto" value="" hidden></p>
                    </file-upload>
                  </v-alert>
                </v-card-text>
                <v-card-actions v-if="editedItem.foto">
                  <v-row dense>
                    <v-col cols="12">
                      <v-btn text @click="dialogoCamera = true" color="primary">Capturar Outra</v-btn>
                    </v-col>
                    <v-col cols="12">
                      <file-upload
                        class="btn btn-primary"
                        input-id="file1"
                        extensions="png,gif,jpeg,jpg"
                        accept="image/png,image/gif,image/jpeg,image/jpg"
                        post-action="/upload/post"
                        v-model="filesRg1"
                        @input-filter="inputFilter"
                        @input-file="inputFileRg1"
                        ref="upload1"
                      >
                        <v-btn color="primary" text>Selecionar Outra</v-btn>
                        <p id="foto" value="" hidden></p>
                      </file-upload>
                    </v-col>
                    <v-col cols="12" v-if="editedIndex == -1">
                      <v-btn color="error" @click="editedItem.foto = ''" text>Remover</v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" v-if="editedIndex == -1">
              <v-checkbox
                v-model="editedItem.enviarLeitor"
                label="Enviar aos Leitores"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoPessoa = false" :disabled="desabilitarBotao">Fechar</v-btn>
          <v-btn text color="success" @click="salvarPessoa" v-if="editedIndex == -1" :disabled="desabilitarBotao">Salvar</v-btn>
          <v-btn text color="success" @click="editarPessoa" v-if="editedIndex != -1" :disabled="desabilitarBotao">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoCamera" max-width="500px">
      <v-card>
        <v-card-title style="padding: 5px 15px 5px 15px">
          Câmera
          <v-spacer></v-spacer>
          <v-btn @click="dialogoCamera = false" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding: 0px">
          <CameraCustom ref="cameraCustom" @error="handleCameraError"></CameraCustom>
          <div align="center" justify="center" style="padding-bottom: 8px">
            <v-btn @click="capturarFoto" fab dark>
              <v-icon large>mdi-camera-iris</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoLogsPessoa" max-width="1000px" scrollable persistent>
      <v-card>
        <v-card-title>Logs de acesso</v-card-title>
        <v-card-text style="padding: 0px">
          <v-data-table
            :headers="tabelaLogs.cabecalho"
            :items="tabelaLogs.conteudo"
            :items-per-page="10"
            dense
            :footer-props="{
              'items-per-page-text': 'Linhas por página',
              'items-per-page-all-text': 'Tudo',
            }"
          >
            <template v-slot:[`item.acao`]="{ item }">
              <p v-if="item.acao == 'SALVAR_USUARIO'" style="margin: 0px">Salvar usuário</p>
              <p v-if="item.acao == 'VINCULAR_USUARIO_GRUPO'" style="margin: 0px">Vincular usuário ao grupo</p>
              <p v-if="item.acao == 'SALVAR_IMAGEM_USUARIO'" style="margin: 0px">Salvar imagem no usuário</p>
              <p v-if="item.acao == 'EXCLUIR_USUARIO'" style="margin: 0px">Excluir usuário</p>
            </template>
            <template v-slot:[`item.erro`]="{ item }">
              <v-icon v-if="item.erro" style="margin: 0px" color="red">mdi-close</v-icon>
              <v-icon v-else style="margin: 0px" color="green">mdi-check</v-icon>
            </template>
            <template v-slot:[`item.dataHora`]="{ item }">
              <p v-if="item.dataHora" style="margin: 0px">{{ formatarDataHora(item.dataHora) }}</p>
              <p v-else style="margin: 0px">N/A</p>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoLogsPessoa = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar ref=chamaSnackbar />
    <v-snackbar v-model="snackbar.exibir" :timeout="snackbar.tempo" :color="snackbar.cor" bottom right>
      {{ snackbar.mensagem }}

      <template v-slot:action="{ attrs }">
        <v-icon
          color="white"
          v-bind="attrs"
          @click="snackbar.exibir = false"
        >
          mdi-close
        </v-icon>
      </template>
    </v-snackbar>
    <loading :active.sync="isLoading" :can-cancel="false" color="#263680" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import axios from 'axios'
import { mapState } from 'vuex'
import CameraCustom from '../componentes/CameraCustom.vue' 
import FileUpload from 'vue-upload-component'
import CpfValidate from '../componentes/validators/rules/cpf'
import io from 'socket.io-client'

export default {
  components: { Snackbar, Loading, CameraCustom, FileUpload },
  data: () => ({
    isLoading: false,
    fullPage: true,
    empresas: [],
    empresaSelecionada: '',
    empresaSelecionadaDados: [],
    responsaveis: [],
    tabela: {
      busca: '',
      cabecalho: [
        { text: 'Foto', value: 'foto', },
        { text: 'Nome', align: 'start', value: 'nome', },
        { text: 'CPF', value: 'cpf' },
        { text: 'ControlID', value: 'faceId' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      carregamento: false,
      conteudo: [],
      modoBusca: false,
      itensPorPagina: 10,
      pagina: 1,
      totalItens: 0,
    },
    tabelaLogs: {
      cabecalho: [
        { text: 'Ação', value: 'acao' },
        { text: 'Sucesso', value: 'erro' },
        { text: 'Mensagem', value: 'mensagem' },
        { text: 'Terminal', value: 'terminalNome' },
        { text: 'Data/Hora', value: 'dataHora' },
      ],
      conteudo: [],
    },
    sexos: [
      { text: 'Masculino', value: 'MASCULINO' },
      { text: 'Feminino', value: 'FEMININO' },
    ],
    tipos: [
      { text: 'Aluno', value: 'ALUNO' },
      { text: 'Responsável', value: 'RESPONSAVEL' },
    ],
    dialogoPessoa: false,
    editedIndex: -1,
    editedItem: {
      nome: '',
      cpf: '',
      turma: '',
      turno: '',
      sala: '',
      matricula: '',
      tipo: '',
      foto: '',
      empresaId: '',
      inicioAcesso: null,
      fimAcesso: null,
      responsavelId: [],
      enviarLeitor: true,
    },
    defaultItem: {
      nome: '',
      cpf: '',
      turma: '',
      turno: '',
      sala: '',
      matricula: '',
      tipo: '',
      foto: '',
      empresaId: '',
      inicioAcesso: null,
      fimAcesso: null,
      responsavelId: [],
      enviarLeitor: true,
    },
    dialogoCamera: false,
    deviceId: null, 
    frontCam: null, 
    googleKey: null,
    filesRg1: [],
    date: new Date().toISOString().substring(0, 10),
    menu1: false,
    menu2: false,
    faceResultado: null,
    dialogoLogsPessoa: false,
    desabilitarBotao: false,
    autocompleteResponsavel: {
      busca: '',
      carregamento: false,
      timeoutId: null,
    },
    socket: null,
    notifications: [],
    snackbar: {
      mensagem: '',
      cor: '',
      tempo: 5000,
      exibir: false,
    },
  }),

  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,
    formTitle () {
      return this.editedIndex === -1 ? 'Adicionar nova pessoa' : 'Editar pessoa'
    },

    totalPages() {
      return this.tabela.totalItens > 0 && this.tabela.itensPorPagina > 0 ? Math.ceil(this.tabela.totalItens / this.tabela.itensPorPagina) : 1
    },
  }),

  watch: {
    dialogoPessoa(val) {
      if (val == false) {
        setTimeout(() => {
          this.editedIndex = -1
          this.editedItem = Object.assign({}, this.defaultItem)
          this.faceResultado = null;
          this.responsaveis = []
        }, 300);
      }
      else {
        this.carregaResponsaveis()
      }
    },

    dialogoCamera(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.cameraCustom) { 
            this.$refs.cameraCustom.startCamera();
          }
        });
      } else {
        if (this.$refs.cameraCustom) { 
            this.$refs.cameraCustom.stopCamera();
        }
      }
    },

    empresas(newEmpresas) {
      if (newEmpresas.length > 0) {
        if (!this.empresaSelecionada || !newEmpresas.some(e => e.id === this.empresaSelecionada)) {
          this.empresaSelecionada = newEmpresas[0].id;
        }
        this.carregaEmpresasDados(this.empresaSelecionada);
        this.carregaPessoas(this.empresaSelecionada);
      }
    },
    
    'editedItem.responsavelId'() {
      this.$nextTick(() => {
        this.autocompleteResponsavel.busca = ''
      })
    },

    dialogoLogsPessoa(val) {
      if (val == false) {
        this.tabelaLogs.conteudo = []
      }
    },
  },

  mounted() {
    if (this.user.tipo == 'ADMIN') {
      this.carregaEmpresas()
    }
    else {
      this.carregaPessoas(this.companyobj.id)
    }
    
    // this.connectSocketIo()
  },

  beforeDestroy() {
    if (this.autocompleteResponsavel.timeoutId) {
      clearTimeout(this.autocompleteResponsavel.timeoutId)
    }

    // Desconecta o socket ao destruir o componente
    if (this.socket) {
      this.socket.disconnect();
    }
  },

  methods: {
    connectSocketIo() {
      let canalWS = this.user.tipo == 'ADMIN' ? this.empresaSelecionadaDados.canalWS : this.companyobj.canalWS;
      
      this.socket = io(baseApiUrl.replace('api/', ''), {
        reconnection: true,
        reconnectionAttempts: 10,
        reconnectionDelay: 1000,
        transports: ['polling', 'websocket'],
        upgrade: false,
        forceNew: true
      });

      this.socket.on('connect', () => {
        // console.log('Conexão estabelecida com o servidor');
      });

      this.socket.on('connect_error', (error) => {
        // console.error('Erro de conexão:', error.message);
        this.$refs.chamaSnackbar.snack("#FF0000", "Erro na conexão WebSocket: " + error.message, "DESCULPE");
      });

      this.socket.on('@' + canalWS, (data) => {
        this.processarNotificacaoWebSocket(data);  
      });

      this.socket.on('disconnect', () => {
        // console.log('Desconectado do servidor');
      });
    },

    processarNotificacaoWebSocket(data) {
      switch (data.status) {
        case "PROCESSANDO":
          this.snackbar.mensagem = data.nome + " está processando";
          this.snackbar.cor = "orange";
          this.snackbar.exibir = true;
          break;
        case "ASSOCIADO":
          this.atualizaPessoa(data)
          this.snackbar.mensagem = data.nome + " foi associado";
          this.snackbar.cor = "green";
          this.snackbar.exibir = true;
          break;
        case "DESASSOCIADO":
          this.snackbar.mensagem = data.nome + " foi desassociado";
          this.snackbar.cor = "red";
          this.snackbar.exibir = true;
          break;
        default:
          break;
      }
    },

    async atualizaPessoa(data) {
      for (let i = 0; i < this.tabela.conteudo.length; i++) {
        if (this.tabela.conteudo[i].id == data.id) {
          this.tabela.conteudo[i].status = data.status
          break
        }
      }
    },

    async carregaEmpresas() {
      await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data.length > 0) {
          this.empresas = response.data
        }
      })
    },

    async carregaEmpresasDados(id) {
      await axios.get(baseApiUrl + 'Empresas/' + id + '?access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        this.empresaSelecionadaDados = response.data
      })

      if (this.user.tipo == 'ADMIN') {
        // this.connectSocketIo();
      }
    },

    async carregaResponsaveis() {
      this.autocompleteResponsavel.carregamento = true

      let whereFilter = {
        "where": {
          "and": [
            { "empresaId": this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id },
            { "tipo": "RESPONSAVEL" }
          ]
        },
        "order": "nome ASC",
        "fields": {"nome": true, "cpf": true, "id": true, "foto": true}
      }

      await axios.get(baseApiUrl + 'Pessoas?filter=' + JSON.stringify(whereFilter) + '&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data) {
          this.responsaveis = response.data
          this.autocompleteResponsavel.carregamento = false
        }
      })
      .catch(error => {
        this.autocompleteResponsavel.carregamento = false
        this.$refs.chamaSnackbar.snack("red", "Problema ao buscar responsáveis. " + error.response.data.error.message, "DESCULPE")
      })
    },

    remove (item) {
      const index = this.friends.indexOf(item.name)
      if (index >= 0) this.friends.splice(index, 1)
    },

    filterResponsaveis(item, queryText) {
      let searchText = queryText.toLowerCase()
      let nome = item.nome ? item.nome.toLowerCase() : ''
      let cpfMascarado = item.cpf ? this.mascaraCPF(item.cpf) : ''
      let cpfDesmascarado = item.cpf ? item.cpf.replace(/\D/g, '') : ''
      
      return nome.includes(searchText) || cpfMascarado.includes(searchText) || cpfDesmascarado.includes(searchText)
    },

    async carregaPessoas(id) {
      this.tabela.carregamento = true
      let skip = (this.tabela.pagina - 1) * this.tabela.itensPorPagina;
      let whereFilter = {
        "where": {
          "and":[
            { "empresaId": id },
          ]
        },
        "limit": this.tabela.itensPorPagina,
        "skip": skip,
        "order": "created DESC"
      }

      whereFilter = JSON.stringify(whereFilter)

      await axios.get(baseApiUrl + 'Pessoas/count?where={"empresaId":"' + id + '"}&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data) {
          this.tabela.totalItens = response.data.count
        }
      })

      await axios.get(baseApiUrl + 'Pessoas?filter=' + whereFilter + '&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data) {
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].cpf.replace(/\D/g, '').length == 11) {
              response.data[i].cpf = this.mascaraCPF(response.data[i].cpf)
            }
          }

          this.tabela.conteudo = response.data
        }
      })
      
      this.tabela.carregamento = false
    },

    abrirDialogo() {
      this.dialogoPessoa = true;
    },

    atualizaDados() {
      this.carregaEmpresasDados(this.empresaSelecionada);
      this.carregaPessoas(this.empresaSelecionada);
    },

    editItem(item) {
      this.isLoading = true
      this.editedIndex = this.tabela.conteudo.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogoPessoa = true;
      this.isLoading = false
    },

    // Função para validar a imagem facial
    async validarFace(base64Image) {
      this.isLoading = true;
      try {
        const hashBase64 = base64Image.split(',')[1]; 
        const response = await axios.post(baseApiUrl + 'Faces/verificarQualidadeImagem?access_token=' + sessionStorage.getItem('accToken'), { hashBase64 });
        this.faceResultado = response.data; 

        if (!response.data.adequada) { 
            this.$refs.chamaSnackbar.snack("orange", `A foto não é adequada: ${response.data.motivo}`, "ATENÇÃO");
        }
        return response.data.adequada;
      } catch (error) {
        this.$refs.chamaSnackbar.snack("red", "Erro ao validar a imagem. Tente novamente.", "ERRO");
        this.faceResultado = { adequada: false, motivo: "Erro de comunicação com o servidor de validação." };
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    async salvarPessoa() {
      this.desabilitarBotao = true
      var vm = this;

      // Validação inicial dos campos obrigatórios
      if (!this.editedItem.nome || !this.editedItem.cpf || !this.editedItem.foto || !this.editedItem.tipo) {
        this.desabilitarBotao = false
        vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos obrigatórios para prosseguir", "ATENÇÃO");
        return;
      }

      if (this.editedItem.tipo == 'ALUNO' && (!this.editedItem.turma || !this.editedItem.turno || !this.editedItem.sala || !this.editedItem.matricula)) {
        this.desabilitarBotao = false
        vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos obrigatórios do aluno para prosseguir", "ATENÇÃO");
        return;
      }

      // Validação do CPF
      if (!CpfValidate(this.editedItem.cpf)) {
        this.desabilitarBotao = false
        vm.$refs.chamaSnackbar.snack("orange", "CPF informado não é válido", "ATENÇÃO");
        return;
      }
      
      // Validação da IMAGEM capturada/selecionada.
      if (!this.editedItem.foto || (this.faceResultado && !this.faceResultado.adequada)) {
        this.desabilitarBotao = false
        vm.$refs.chamaSnackbar.snack("orange", `Por favor, capture ou selecione uma foto adequada. ${this.faceResultado ? this.faceResultado.motivo : ''}`, "ATENÇÃO");
        return;
      }
     
      this.isLoading = true;
      this.editedItem.empresaId = this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id;
      this.editedItem.nome = this.editedItem.nome.toUpperCase();
      this.editedItem.cpf = this.editedItem.cpf.replace(/\D/g, '');
      this.editedItem.urlFoto = baseApiUrl;

      await axios.post(baseApiUrl + 'Pessoas/nova?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
      .then(response => {
        if (response.data) {
          this.desabilitarBotao = false
          this.dialogoPessoa = false;
          vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO");

          if (this.tabela.modoBusca) {
            this.buscarItem();
          } else {
            this.carregaPessoas(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id);
          }
          this.isLoading = false;
        }
      })
      .catch(error => {
        this.desabilitarBotao = false
        this.isLoading = false;
        vm.$refs.chamaSnackbar.snack("#FF0000", error.response.data.error.message, "DESCULPE");
      });
    },

    async editarPessoa() {
      this.desabilitarBotao = true
      var vm = this;
      
      // Validação inicial dos campos obrigatórios
      if (!this.editedItem.nome || !this.editedItem.cpf || !this.editedItem.foto || !this.editedItem.tipo) {
        this.desabilitarBotao = false
        vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos obrigatórios para prosseguir", "ATENÇÃO");
        return;
      }

      // Validação para campos obrigatórios de um aluno
      if (this.editedItem.tipo == 'ALUNO' && (!this.editedItem.turma || !this.editedItem.turno || !this.editedItem.sala || !this.editedItem.matricula)) {
        this.desabilitarBotao = false
        vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos obrigatórios do aluno para prosseguir", "ATENÇÃO");
        return;
      }
      
      // Validação do CPF
      if (!CpfValidate(this.editedItem.cpf)) {
        this.desabilitarBotao = false
        vm.$refs.chamaSnackbar.snack("orange", "CPF informado não é válido", "ATENÇÃO");
        return;
      }

     // Validação da IMAGEM capturada/selecionada.
      if (!this.editedItem.foto || (this.faceResultado && !this.faceResultado.adequada)) {
        this.desabilitarBotao = false
        vm.$refs.chamaSnackbar.snack("orange", `Por favor, capture ou selecione uma foto adequada. ${this.faceResultado ? this.faceResultado.motivo : ''}`, "ATENÇÃO");
        return;
      }

      this.isLoading = true;
      this.editedItem.nome = this.editedItem.nome.toUpperCase();
      this.editedItem.cpf = this.editedItem.cpf.replace(/\D/g, '');
      this.editedItem.urlFoto = baseApiUrl;

      await axios.post(baseApiUrl + 'Pessoas/editar?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
      .then(response => {
        if (response.data) {
          this.desabilitarBotao = false
          this.isLoading = false;
          this.dialogoPessoa = false;
          vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO");

          if (this.tabela.modoBusca) {
            this.buscarItem();
          } else {
            this.carregaPessoas(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id);
          }
        }
      })
      .catch(error => {
        this.desabilitarBotao = false
        this.isLoading = false;
        vm.$refs.chamaSnackbar.snack("#FF0000", error.response.data.error.message, "DESCULPE");
      });
    },

    async deleteItem(item) {
      var vm = this;
      var r = confirm('Realmente deseja EXCLUIR a pessoa ' + item.nome + '?')

      if (r == true) {
        this.isLoading = true

        await axios.post(baseApiUrl + 'Pessoas/excluir?access_token=' + sessionStorage.getItem('accToken'), {"pessoaId": item.id})
        .then(response => {
          vm.$refs.chamaSnackbar.snack("green", response.data.mensagem, "SUCESSO")
          
          if (this.tabela.modoBusca) {
            this.buscarItem()
          } else {
            this.carregaPessoas(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
          }

          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#FF0000", error.response.data.error.message, "DESCULPE")
        })
      }
    },

    // função para capturar foto sem a validação da imagem
    async capturarFoto() {
      this.editedItem.foto = await this.$refs.cameraCustom.capturePhoto(); 
      this.dialogoCamera = false;
    },

    // função para capturar foto com validação da imagem
    /* async capturarFoto() {
      const fotoBase64 = await this.$refs.cameraCustom.capturePhoto(); 
      const imagemAdequada = await this.validarFace(fotoBase64);
      if (imagemAdequada) {
        this.editedItem.foto = fotoBase64;
        this.dialogoCamera = false;
        // AVISO DE SUCESSO: Foto capturada e validada com sucesso.
        this.$refs.chamaSnackbar.snack("green", "Imagem adequada para biometria.", "SUCESSO");
      } else {
        // Se a imagem não for adequada, o diálogo da câmera permanece aberto com o feedback.
        // O snackbar já exibirá o motivo da falha diretamente da função validarFace.
      }
    }, */
    
    handleCameraError(message) {
      this.$refs.chamaSnackbar.snack("red", message, "ERRO");
    },

    calculaIdade(dataNasc) {
      let dataAtual = new Date();
      let anoAtual = dataAtual.getFullYear();
      let anoNascParts = dataNasc.split('/');
      let diaNasc = anoNascParts[0];
      let mesNasc = anoNascParts[1];
      let anoNasc = anoNascParts[2];
      let idade = anoAtual - anoNasc;
      let mesAtual = dataAtual.getMonth() + 1;
      if (mesAtual < mesNasc) {
        idade--;
      } else {
        if (mesAtual == mesNasc) {
          if (new Date().getDate() < diaNasc ) {
            idade--;
          }
        }
      }
      return idade;
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },

    inputFileRg1(newFile, oldFile) {
      if (newFile && !oldFile) {
        var reader = new FileReader()
        var file = this.filesRg1[0]

        //salva a base64 na variável
        reader.onloadend = async () => { // Usar async aqui para poder await validarFace
          this.editedItem.foto = reader.result;
        };

        //Gera base64
        reader.readAsDataURL(file.file);
      }

      if (newFile && oldFile) {
        // update
      }

      if (!newFile && oldFile) {
        // remove
      }
    },

    mascaraCPF(cpf) {
      cpf = cpf.replace(/\D/g, '');

      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

      return cpf;
    },

    async associarItem(item) {
      let vm = this
      this.isLoading = true

      await axios.post(baseApiUrl + 'ServiceControlId/novoUsuario?access_token' + sessionStorage.getItem('accToken'), {"pessoaId": item.id})
      .then(response => {
        if (response.data) {
          vm.$refs.chamaSnackbar.snack("green", "Pessoa associada! Pode levar até 01 minuto para que o cadastro seja enviado aos terminais biométricos.", "SUCESSO")
        }
      })
      .catch(error => {
        vm.$refs.chamaSnackbar.snack("red", "Problema ao associar pessoa. " + error.response.data.error.message, "DESCULPE")
      })

      this.isLoading = false
    },

    async desassociarItem(item) {
      let vm = this
      this.isLoading = true

      await axios.post(baseApiUrl + 'ServiceControlId/excluirUsuario?access_token=' + sessionStorage.getItem('accToken'), {"pessoaId": item.id})
      .then(response => {
        if (response.data) {
          vm.$refs.chamaSnackbar.snack("green", "Pessoa desassociada! Pode levar até 01 minuto para que o cadastro seja removido dos terminais biométricos.", "SUCESSO")
        }
      })
      .catch(() => {
        vm.$refs.chamaSnackbar.snack("red", "Pessoa não localizada na base para desassociar.", "DESCULPE")
      })

      this.isLoading = false
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    async buscarItem(pagina) {
      if (this.tabela.busca.length >= 3) {
        this.tabela.carregamento = true

        let paginaBusca = pagina

        if (!this.tabela.modoBusca && pagina != 1) {
          paginaBusca = 1
        }

        let skip = (paginaBusca - 1) * this.tabela.itensPorPagina;
        let whereCount = null
        let whereFilter = {
          limit: this.tabela.itensPorPagina,
          skip: skip,
          order: "created DESC"
        }

        if (!isNaN(this.tabela.busca.replace(/\D/g, '')) && parseInt(this.tabela.busca.replace(/\D/g, '')) > 0) {
          whereCount = {
            or: [
              { cpf: {"regexp": "/" + this.tabela.busca + "/i" } },
              { cpf: {"regexp": "/" + this.mascaraCPF(this.tabela.busca) + "/i"} }
            ]
          }

          whereFilter.where = {
            or: [
              { cpf: {"regexp": "/" + this.tabela.busca.replace(/\D/g, '') + "/i" } },
              {cpf: {"regexp": "/" + this.mascaraCPF(this.tabela.busca) + "/i" }},
            ]
          }
        } else {
          whereCount = {
            nome: {"regexp": "/" + this.tabela.busca + "/i"}
          }

          whereFilter.where = {
            nome: {regexp: '/' + this.tabela.busca + '/i'},
          }
        }

        whereCount = JSON.stringify(whereCount)
        whereFilter = JSON.stringify(whereFilter)

        await axios.get(baseApiUrl + 'Pessoas/count?where=' + whereCount + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.totalItens = response.data.count
          }
        })
        .catch(error => {
          this.tabela.carregamento = false
          this.$refs.chamaSnackbar.snack("red", "Problema ao obter quantidade da busca. " + error.response.data.error.message, "DESCULPE")
          return
        })

        await axios.get(baseApiUrl + 'Pessoas?filter=' + whereFilter + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].cpf.replace(/\D/g, '').length == 11) {
                response.data[i].cpf = this.mascaraCPF(response.data[i].cpf)
              }
            }

            this.tabela.conteudo = response.data
            this.tabela.modoBusca = true

            if (!this.tabela.modoBusca && pagina != 1) {
              this.tabela.pagina = paginaBusca
            } else {
              this.tabela.pagina = parseInt(pagina)
            }
          }
        })
        .catch(error => {
          this.tabela.carregamento = false
          this.$refs.chamaSnackbar.snack("red", "Problema ao buscar pessoas. " + error.response.data.error.message, "DESCULPE")
          return
        })

        this.tabela.carregamento = false
      }
    },

    sairModoBusca() {
      this.tabela.pagina = 1
      this.tabela.modoBusca = false
      this.tabela.busca = ''
      this.carregaPessoas(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
    },

    pegaPaginaPaginacao(pagina) {
      if (this.tabela.modoBusca) {
        this.buscarItem(pagina)
      } else {
        this.carregaPessoas(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
      }
    },

    async verLogs(item) {
      this.isLoading = true

      await axios.get(baseApiUrl + 'Pessoas/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data) {
          this.tabelaLogs.conteudo = response.data.logsEnvioLeito
          this.isLoading = false
          this.dialogoLogsPessoa = true
        }
      })

    },

    formatarDataHora(date) {
      if (!date) return null

      let data = date.split('T')[0]
      let hora = date.split('T')[1]
      let [year, month, day] = data.split('-')
      
      return `${day}/${month}/${year}` + " às " + hora.substring(0, 8)
    },

    corStatus(status) {
      switch (status) {
        case 'PROCESSANDO':
          return 'orange'
        case 'ASSOCIADO':
          return 'green'
        case 'DESASSOCIADO':
          return 'red'
        default:
          return ''
      }
    },

    retornaTipoPessoa(pessoa) {
      let tipo = ''

      for (let i = 0; i < this.tipos.length; i++) {
        if (pessoa.tipo == this.tipos[i].value) {
          tipo = this.tipos[i].text
          break
        }
      }

      return tipo
    },
  },
}
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
  
  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }

  .table-blur {
    filter: blur(5px);
    pointer-events: none; 
    opacity: 0.6; 
  }
</style>